module.exports = __webpack_public_path__ + "img/poo-storm.aee2fdb7.svg";